"use client";

import { Check, X } from "lucide-react";
import { getPasswordChecks } from "@/lib/password";

export function PasswordRequirements({ password }: { password: string }) {
  const checks = getPasswordChecks(password);
  const items = [
    ["8+ characters", checks.length],
    ["Uppercase", checks.uppercase],
    ["Lowercase", checks.lowercase],
    ["Number", checks.number],
    ["Special character", checks.special],
  ] as const;

  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {items.map(([label, valid]) => (
        <span
          key={label}
          className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[10px] font-bold ${
            valid
              ? "border-emerald-100 bg-emerald-50 text-emerald-700"
              : "border-slate-200 bg-white text-slate-400"
          }`}
        >
          {valid ? <Check size={11} /> : <X size={11} />}
          {label}
        </span>
      ))}
    </div>
  );
}
